import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';

export type ReturnCode = "Yes" | "No" | undefined
export interface Props {
    onClick?: (result?: ReturnCode)=>any
    open: boolean
    title: string
    message: string
    label?: {
        yes?: string
        no?: string
    }

}
function ConfirmDialog(props: Props) {

    const close = (result: ReturnCode)=>{
        props?.onClick?.(result)
    }

    return (
        <Dialog
            open={props.open}
            onClose={()=>close(undefined)}
            >
            <DialogTitle>
                {props.title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={()=>close("Yes")} color="primary">
                    {props?.label?.yes || "Yes"}
                </Button>
                <Button onClick={()=>close("No")}>
                    {props?.label?.no || "No"}
                </Button>
            </DialogActions>

        </Dialog>
    )
} 
export default ConfirmDialog